import Spinner from "react-bootstrap/Spinner";

function Loader() {
  return (
    <div className="loader-center">
      <Spinner
        animation="border"
        role="status"
        // variant="primary"
        style={{ border: "1px solid #6a27ea", borderRightColor: "transparent" }}
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}

export default Loader;
